import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_ACCOUNT_BASE_URL}/api/v1/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      headers.set("api-key", `${process.env.REACT_APP_OKR_APP_TOKEN}`);
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllDepartments: builder.query({
      query: () => `department`,
    }),
    createNewDepartments: builder.mutation({
      query: (data) => ({
        url: `admin/departments`,
        method: "POST",
        body: data,
      }),
    }),
    getAllDivisions: builder.query({
      query: () => `divisions`,
    }),
    getAllRegions: builder.query({
      query: () => `regions`,
    }),
    getAllUsers: builder.query({
      query: () => `admin/users`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllDepartmentsQuery,
  useGetAllDivisionsQuery,
  useGetAllRegionsQuery,
  useGetAllUsersQuery,
  useCreateNewDepartmentsMutation,
} = appApi;
